import { SET_STORES_LIST, SET_SUPPLIERS_LIST } from '../action-types'

export const setSuppliers = suppliers => {
    return {
        type: SET_SUPPLIERS_LIST,
        payload: suppliers
    };
};

export const setStores = stores => {
    return {
        type: SET_STORES_LIST,
        payload: stores
    };
};



// WEBPACK FOOTER //
// ./src/redux-store/actions/data-actions.js